module.exports = __webpack_public_path__ + "epilace_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/epilace_2_after_tn.jpg
// module id = 1413
// module chunks = 0